var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 16,
  viewBox: "0 0 12 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M6 0a4 4 0 0 1 4 4v2l.141.005A2 2 0 0 1 12 8v6c0 1.105-.902 2-2.009 2H2.01A2 2 0 0 1 0 14V8c0-1.102.898-1.996 2-2V4l.005-.2A4 4 0 0 1 6 0m1 10H5v2h2zM6 2a2 2 0 0 0-2 2v2h4V4l-.005-.15A2 2 0 0 0 6 2"
})));
export default SvgLocked;